import React, { useState, useEffect } from "react";
import moment from "moment";
import { usePopup } from "../../common/contexts/PopupContext";
import { useParams } from "react-router-dom";
import useMaintenance from "../../common/hooks/pages/useMaintenance";
import { useMutation } from "react-query";

const Automation = ({ maintenanceData }) => {
  const { toast } = usePopup();
  const { id } = useParams();
  const { updateMaintenance } = useMaintenance();

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");

  function convertUTCtoIST(utcDateTimeString) {
    const utcDateTime = new Date(utcDateTimeString);
    const istDateTimeString = utcDateTime.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
    });
    return istDateTimeString;
  }

  const { mutate: updateMaintenanceMutate } = useMutation({
    mutationFn: updateMaintenance,
    onSuccess: (res) => {
      const { message } = res?.data || {};
      toast(message, "success");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while updating Maintenance!";
      toast(message, "error");
    },
  });

  useEffect(() => {
    if (maintenanceData) {
      const { scheduledStart, scheduledEnd } = maintenanceData;
      const startDate = convertUTCtoIST(scheduledStart);
      const start = new Date(scheduledStart);
      const end = new Date(scheduledEnd);

      if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
        const timeDifference = end.getTime() - start.getTime();
        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        setHour(hours);
        setMinute(minutes);
      }

      const newDate = startDate?.split(",")[0];
      const [day, month, year] = newDate.split("/");
      const start_Date = `${year}-${month?.padStart(2, "0")}-${day?.padStart(
        2,
        "0"
      )}`;
      setDate(start_Date);
      setTime(startDate?.split(",")[1]?.slice(1, 6));
    }
  }, [maintenanceData]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!date || !time) {
      toast("Date or Time is missing", "error");
      return;
    }
    const startDateTime = new Date(`${date}T${time}`);
    let endDateTime = new Date(`${date}T${time}`);
    if (hour || minute) {
      endDateTime.setHours(endDateTime.getHours() + parseInt(hour || 0));
      endDateTime.setMinutes(endDateTime.getMinutes() + parseInt(minute || 0));
    }
    updateMaintenanceMutate({
      maintenanceId: id,
      scheduledStart: startDateTime,
      scheduledEnd: endDateTime,
    });
  };

  return (
    <div>
      <form className="space-y-6" onSubmit={submitHandler}>
        <div className={`my-4 `}>
          <div className="text-1xl font-bold">Scheduled Time</div>
          <input
            type="date"
            onChange={(e) => setDate(e.target.value)}
            value={date}
            min={moment().format("YYYY-MM-DD")}
            className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
            required
          />
          <input
            type="time"
            onChange={(e) => setTime(e.target.value)}
            value={time}
            className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
            required
          />

          <input
            id="hours"
            type="number"
            onChange={(e) => setHour(e.target.value)}
            value={hour}
            className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
          />
          <input
            id="minutes"
            type="number"
            value={minute}
            onChange={(e) => setMinute(e.target.value)}
            className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
          />
        </div>
        <p>
          Automation options are hidden because you are manually completing the
          scheduled maintenance.
        </p>
        <div
          className="actions action-buttons-aligner"
          style={{ paddingTop: "20px" }}
        >
          <button type="submit" className="cpt-button size-small style-primary">
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default Automation;
